// useDebounce.js
import useSWR from 'swr'

import * as T from 'types'
import * as E from 'types/enums'

import { fetch } from '../../fetchers'

export type ForSaleType = 'For Sale' | 'In Contract' | 'Sold'

export interface IQuery {
  forSaleTypes?: ForSaleType[]
  propertyTypes?: E.HomeTypeEnum[]
  priceMin?: number
  priceMax?: number
  bedsMin?: number
  bedsMax?: number
  bathsMin?: number
  bathsMax?: number
  // sqftMin?: number
  // sqftMax?: number
  // lotSizeMin?: number
  // lotSizeMax?: number
  // yearBuiltMin?: number
  // yearBuiltMax?: number
  // parkingSpaces?: number
  // stories?: number
  // waterFront?: boolean
  // pool?: boolean
  // garage?: boolean
  // airConditioning?: boolean
  [key: string]: T.ValueOf<IQuery>
}

export const queryKeys: (keyof IQuery)[] = [
  'forSaleTypes',
  'propertyTypes',
  'priceMin',
  'priceMax',
  'bedsMin',
  'bedsMax',
  'bathsMin',
  'bathsMax',
]

export type SortKey = 'featured' | 'firstPublishedAt' | 'price' | 'bed' | 'sqft'

interface IFetchOptions {
  coordinates?: [number, number][] | null
  limit?: number
  skip?: number
  query?: IQuery
  sortKey?: SortKey
  sortDirection?: 'ascending' | 'descending'
}

// Note: box param makes the BE query faster w/ better distributed results
// but it will only work with rectangles, not arbitrary polygons
export const useListingsWithinLocation = ({
  coordinates,
  limit = 500,
  skip = 0,
  sortKey,
  sortDirection = 'descending',
  query = {},
}: IFetchOptions) => {
  const stringCoordinates = JSON.stringify(coordinates)

  let key = coordinates
    ? `/listings/location/polygon/${stringCoordinates}?limit=${limit}&skip=${skip}`
    : null

  if (key) {
    if (sortKey) key += `&sort=${sortKey}`

    if (sortKey && sortDirection) key += `&sortDirection=${sortDirection}`

    // converts query object to query string
    const queryString = Object.entries(query)
      .filter(([, value]) => value !== undefined)
      .map(([queryKey, value]) => {
        if (Array.isArray(value)) {
          return value.map(arrayValue => `${queryKey}[]=${arrayValue}`).join('&')
        }

        return `${queryKey}=${value}`
      })
      .join('&')

    if (queryString) key += `&${queryString}`
  }

  const response = useSWR<{ count: number; data: T.IListing[] }>(key, fetch, {
    dedupingInterval: 5000,
    revalidateOnFocus: false,
  })

  return {
    ...response,
    foundListings: response?.data?.data,
    count: response?.data?.count,
  }
}
